import { render, staticRenderFns } from "./ViewDashboard.vue?vue&type=template&id=32d36455&scoped=true&lang=pug"
import script from "./ViewDashboard.vue?vue&type=script&lang=js"
export * from "./ViewDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d36455",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32d36455')) {
      api.createRecord('32d36455', component.options)
    } else {
      api.reload('32d36455', component.options)
    }
    module.hot.accept("./ViewDashboard.vue?vue&type=template&id=32d36455&scoped=true&lang=pug", function () {
      api.rerender('32d36455', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/chatbots/modules/dashboard/ViewDashboard.vue"
export default component.exports